export const GOOGLE_CLIENT_ID = '672553685138-m62rgnm2900481scaosle9omfk159865.apps.googleusercontent.com'
// export const GOOGLE_REDIRECT_URI = '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'